import { mapState } from "pinia";
import { defineComponent } from "vue";
import componentBase from "~/components/component-base";
import WidgetIndicator from "~/components/widget-indicator/widget-indicator.vue";
import { AvoltaAlarmEnum } from "~/configs/alarms/avolta-alarm.model";
import { getStationAlarms, isStationInGasAlarm, isStationInTrouble, isStationOffline } from "~/misc/station-utils";
import { useStationStore } from "~/store/station.store";

export default defineComponent({

    extends: componentBase,

    components: {
        WidgetIndicator,
    },


    computed: {
        ...mapState(useStationStore, ['stations']),

        gasCount(): number {
            return this.stations.filter(s => s.status !== 'disabled' && isStationInGasAlarm(s)).length;
        },

        troubleCount(): number {
            return this.stations.filter(s => s.status !== 'disabled' && isStationInTrouble(s)).length;
        },

        offlineCount(): number {
            return this.stations.filter(s => s.status !== 'disabled' && isStationOffline(s)).length;
        },

        okCount(): number {
            return this.stations.filter(s => 
                s.status !== 'disabled' 
                && !isStationInGasAlarm(s)
                && !isStationInTrouble(s) 
                && !isStationOffline(s)
            ).length;
        },

        storedCount(): number {
            return this.stations.filter(s => 
                s.status == 'disabled' 
                && getStationAlarms(s).map(a => a.name).includes(AvoltaAlarmEnum.CH4_eol_alarm)
            ).length;
        }

    }
});